import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Layout from "@/components/Layout";
import { Card } from "@/components/ui/card";
import { STAGE_META, API } from "@/lib/api";

export default function Shared() {
  const { token } = useParams();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    axios.get(`${API}/shared/${token}`)
      .then((r) => setDoc(r.data))
      .catch(() => setErr(true));
  }, [token]);

  if (err) {
    return (
      <Layout showNav={false}>
        <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="shared-error">
          <h1 className="text-2xl mb-2" style={{ fontFamily: 'Manrope' }}>Link not found</h1>
          <p className="text-muted-foreground">This shared session may have been revoked.</p>
        </div>
      </Layout>
    );
  }

  if (!doc) {
    return (
      <Layout showNav={false}>
        <div className="max-w-2xl mx-auto px-6 py-16 text-muted-foreground">Loading…</div>
      </Layout>
    );
  }

  return (
    <Layout showNav={false}>
      <div className="max-w-3xl mx-auto px-6 py-16 fade-in" data-testid="shared-view">
        <p className="text-sm uppercase tracking-widest text-muted-foreground mb-2">Shared coaching session</p>
        <h1 className="text-3xl sm:text-4xl tracking-tight mb-10" style={{ fontFamily: 'Manrope' }}>
          {doc.title}
        </h1>

        {doc.final_summary && (
          <Card className="p-8 rounded-3xl border-border/60 shadow-none mb-8">
            <h2 className="text-xl font-medium mb-4" style={{ fontFamily: 'Manrope' }}>Final summary</h2>
            <div className="whitespace-pre-wrap text-foreground/85 leading-relaxed">{doc.final_summary}</div>
          </Card>
        )}

        <Card className="p-6 rounded-2xl border-border/60 shadow-none">
          <h2 className="font-medium mb-4" style={{ fontFamily: 'Manrope' }}>Step notes</h2>
          <div className="space-y-5">
            {STAGE_META.map((s) => {
              const sd = doc.stages?.[String(s.stage)];
              if (!sd?.summary && !(sd?.messages?.length)) return null;
              return (
                <div key={s.stage} className="border-l-2 border-primary/30 pl-4">
                  <p className="text-xs uppercase tracking-widest text-muted-foreground mb-1">
                    Step {s.stage} — {s.title}
                  </p>
                  {sd?.summary && <p className="text-sm text-foreground/80 leading-relaxed">{sd.summary}</p>}
                </div>
              );
            })}
          </div>
        </Card>

        <p className="text-center text-xs text-muted-foreground mt-10">
          Generated with Conflict Resolution Assistant
        </p>
      </div>
    </Layout>
  );
}
